export default __webpack_public_path__ + "media/zurb/img/about/jon/jon-image3-e4817ffb96bc79e11a0ea9bdf6728f85.png";